<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>
  <mat-form-field class="full-width">
    <mat-select placeholder="Reason" [(ngModel)]="cancellationReason" required>
      <mat-option *ngFor="let reason of cancellationReasons" [value]="reason.id">{{reason.name}}</mat-option>          
    </mat-select>
  </mat-form-field>
  <mat-form-field class="full-width">
    <input matInput placeholder="Comment" [(ngModel)]="cancellationComment">
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="primary">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="accent" [disabled]="cancellationReason == null">Confirm</button>
</div>